import { Column, Form, Progress, Row } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useContext } from "react";

import UnifiedUpload from "../../../../components/UnifiedUpload";
import FileUploadContext from "../../../../contexts/FileUploadContext";
import formatFileSize from "../../../../utils/formatFileSize";

export const summaryServiceLines = [
  { label: "Container Loading", value: "containerLoading" },
  { label: "Lab Testing", value: "labTesting" },
  { label: "PSR", value: "psr" },
  { label: "Other Project Files", value: "otherProjectFiles" },
];

const ReportUploadForm = ({ formInstance, shouldAllowZip }) => {
  const {
    fileUploadPercentComplete,
    fileUploadStatus,
    fileUploadError,
    fileList,
  } = useContext(FileUploadContext);

  return (
    <Form
      form={formInstance}
      initialValues={{}}
      layout="vertical"
      requiredMark={true}
    >
      <Row gutter={45}>
        <Column span={24}>
          <Form.Item
            name="link"
            label="Upload File"
            rules={[{ required: true, message: "File is required" }]}
          >
            <UnifiedUpload shouldAllowZip={shouldAllowZip} />
          </Form.Item>
        </Column>
        <Column span={24}>
          {fileUploadStatus && (
            <>
              <p>{fileUploadStatus}</p>
              <p>
                Total size:{" "}
                {formatFileSize(
                  fileList.reduce(
                    (sum, item) => sum + item.originalFileObj.size,
                    0
                  )
                )}{" "}
              </p>

              <Progress
                percent={fileUploadPercentComplete || 0}
                {...(fileUploadError && { status: "exception" })}
              />
            </>
          )}
        </Column>
      </Row>
    </Form>
  );
};

ReportUploadForm.defaultProps = {
  formInstance: {
    setFieldsValue: () => {},
    getFieldsValue: () => {},
    resetFields: () => {},
  },
  summaryReport: false,
  shouldAllowZip: false,
  clientReport: false,
};

ReportUploadForm.propTypes = {
  formInstance: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    resetFields: PropTypes.func,
  }),
  summaryReport: PropTypes.bool,
  clientReport: PropTypes.bool,
  shouldAllowZip: PropTypes.bool,
};

export default ReportUploadForm;
